import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

import MainFooter from "./mainFooter";
import MainHeader from "./mainHeader";
import Sidebar from "./sidebar";

const MainLayout = () => {
  const { pathname } = useLocation();
  const kaydiranKap = useRef(null);

  /*
    EPS-5120 (3. bulgu) — menüden sayfa değiştirince yeni sayfa ortasından
    açılıyordu.

    Sayfayı kaydıran şey pencere değil, aşağıdaki `overflow-y-auto` kabı; ve bu
    kap `<Outlet />`in DIŞINDA, yani rota değişince unmount olmuyor. Dolayısıyla
    React Router'ın pencereye dayalı kaydırma davranışı burada hiç devreye
    girmiyor ve kabın `scrollTop` değeri önceki sayfadan devrediyor.

    Replikada ölçüldü: Genel Bakış'ta 700 px aşağı inip menüden Ürünler'e
    geçince `scrollTop` mobilde 221, web'de 134 kalıyordu (0 olması gerekirken) —
    kullanıcı sayfanın başında sandığı için "Ürün Ekle" ve arama alanını
    göremiyordu.

    Çözüm: yol değişince kabı başa sar.
  */
  useEffect(() => {
    kaydiranKap.current?.scrollTo({ top: 0, left: 0 });
  }, [pathname]);

  return (
    <div className="relative flex h-screen w-full overflow-hidden bg-[#f5f5f7]">
      <Sidebar />
      <div className="flex h-screen w-full flex-col overflow-hidden">
        <MainHeader />
        <div ref={kaydiranKap} className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
        <MainFooter />
      </div>
    </div>
  );
};

export default MainLayout;
